import { createFeatureSelector, createSelector } from '@ngrx/store'
import { RAFFLES_FEATURE_KEY, RafflesState, rafflesAdapter } from './raffles.reducer'

export const selectRafflesState = createFeatureSelector<RafflesState>(RAFFLES_FEATURE_KEY)

const { selectAll, selectEntities } = rafflesAdapter.getSelectors()

export const selectRafflesLoaded = createSelector(selectRafflesState, (state: RafflesState) => state.loaded)

export const selectAllRaffles = createSelector(selectRafflesState, (state: RafflesState) => selectAll(state))

export const selectRafflesEntities = createSelector(selectRafflesState, (state: RafflesState) => selectEntities(state))

export const selectSelectedId = createSelector(selectRafflesState, (state: RafflesState) => state.selectedId)

export const selectCount = createSelector(selectRafflesState, (state: RafflesState) => state.count)

export const selectEntity = createSelector(selectRafflesEntities, selectSelectedId, (entities, selectedId) =>
  selectedId ? entities[selectedId] : undefined,
)
